import './form.css'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { registerUser } from '../../redux/apiCalls/authApiCall'
import swal from 'sweetalert'

const Register = () => {
	const [username, setUsername] = useState('')
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const dispatch = useDispatch()
	const { registerMessage } = useSelector((state) => state.auth)
	const nav = useNavigate()

	const formSubmitHandler = (e) => {
		e.preventDefault()
		if (username.trim() === '') return toast.error('Username is required')
		if (email.trim() === '') return toast.error('Email is required')
		if (password.trim() === '') return toast.error('Password is required')

		dispatch(registerUser({ username, email, password }))
		if (registerMessage) {
			swal({
				title: registerMessage,
				icon: 'success',
			}).then((isOk) => {
				if (isOk) {
					nav('/login')
				}
				
			})
		}
	}

	return (
		<section className="form-page-bg">
			<div className="form-container">
				<form onSubmit={formSubmitHandler} className="form">
					<h1 className="form-title">Create new account</h1>

					<div className="form-group">
						<label htmlFor="username" className="form-label">
							Username
						</label>
						<input
							onChange={(e) => setUsername(e.target.value)}
							value={username}
							type="text"
							id="username"
							placeholder="Enter your name"
							className="form-input"
						/>
					</div>

					<div className="form-group">
						<label htmlFor="email" className="form-label">
							Email
						</label>
						<input
							onChange={(e) => setEmail(e.target.value)}
							value={email}
							type="email"
							id="email"
							placeholder="Your Gmail to verify"
							className="form-input"
						/>
					</div>

					<div className="form-group">
						<label htmlFor="password" className="form-label">
							Password
						</label>
						<input
							onChange={(e) => setPassword(e.target.value)}
							value={password}
							type="password"
							id="password"
							placeholder="Enter your password"
							className="form-input"
						/>
					</div>

					<button type="submit" className="form-btn">
						Register
					</button>

					<div className="form-footer">
						Already have an account? <Link to="/login">Login</Link>
					</div>
				</form>
			</div>
		</section>
	)
}

export default Register
